import { Component, OnInit } from '@angular/core';

import { SearchFilterPipe } from '../../shared/pipes/search-filter.pipe';
import { LocationsService } from './locations.service';

@Component({
	selector: 'crm-locations',
	templateUrl: './locations.component.html'
})
export class LocationsComponent implements OnInit {
	public searchTerm: string;

	constructor(public locationsService: LocationsService, private searchFilterPipe: SearchFilterPipe) {}

	ngOnInit() {
		this.getLocations();
	}

	public getLocations(): void {
		this.locationsService.getAllLocationsForClient().subscribe((locations) => {
			this.locationsService.locations = locations;
		});
	}

	public onSearchClear(): void {
		this.searchTerm = null;
	}

	public onSearchKeyup(): void {
		this.searchFilterPipe.transform(this.locationsService.locations, this.searchTerm);
	}
}
